import React, { useContext, useState } from 'react';
import styles from './styles/NavbarSearch.module.css';
import SearchContext from '../../../context/SearchContext';
import { useNavigate } from 'react-router-dom';
import { FaSearch, FaArrowLeft } from 'react-icons/fa';
import { FaChevronDown } from 'react-icons/fa';


const NavbarSearch = ({ isMobile, setIsSearchExpanded, inline, fullWidth  }) => {
    const { setSearchQuery, setSearchType } = useContext(SearchContext);
    const [inputValue, setInputValue] = useState('');
    const [searchType, setSearchTypeLocal] = useState('scenario');
    const navigate = useNavigate();

    const handleSearch = () => {
        const trimmedInput = inputValue.trim();
        if (trimmedInput !== '') {
            const isTag = trimmedInput.startsWith('#');
            const query = isTag ? trimmedInput.slice(1) : trimmedInput;
            setSearchQuery(query);
            setSearchType(searchType);
            navigate(`/search?query=${query}&type=${searchType}&tag=${isTag}`);
        }
    };

    const handleTypeChange = (e) => {
        setSearchTypeLocal(e.target.value);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };

    const handleBackClick = () => {
        setIsSearchExpanded(false);
    };

    return (
        <div className={`${styles.searchContainer} ${fullWidth ? styles.fullWidth : ''}`}>
            {/* {isMobile && (
                <FaArrowLeft className={styles.backIcon} onClick={handleBackClick} />
            )} */}
            <div className={styles.searchBoxWrapper}>
                <input
                    type="text"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    onKeyPress={handleKeyPress}
                    placeholder="Search"
                    className={styles.searchBox}
                />
                {/* <FaSearch onClick={handleSearch} className={styles.searchIcon} /> */}
                <FaSearch className={styles.searchIcon} />
            </div>
            <div className={styles.searchOption}>
                <select onChange={handleTypeChange} className={styles.searchSelect}>
                    <option value="scenario">Scenario</option>
                    <option value="user">User</option>
                </select>
                <FaChevronDown className={styles.selectArrow} />
            </div>
        </div>
    );
};

export default NavbarSearch;
